import { render, staticRenderFns } from "./transfer-order.vue?vue&type=template&id=50d80b39&scoped=true&"
import script from "./transfer-order.vue?vue&type=script&lang=js&"
export * from "./transfer-order.vue?vue&type=script&lang=js&"
import style0 from "./transfer-order.vue?vue&type=style&index=0&id=50d80b39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d80b39",
  null
  
)

export default component.exports